'use client';

import { c as _c } from "react/compiler-runtime";
import { Pagination } from '@/components/Pagination/Pagination';
import { useFilteredBlogPostState } from './FilteredBlogPostProvider';
export function FilteredBlogPostPagination() {
  const $ = _c(3);
  const {
    filteredPostIds,
    postsPerPage
  } = useFilteredBlogPostState();
  let t0;
  if ($[0] !== filteredPostIds.length || $[1] !== postsPerPage) {
    t0 = filteredPostIds.length > 0 ? <div className="flex flex-row items-center justify-center p-4 md:p-6"><Pagination itemsPerPage={postsPerPage} itemCount={filteredPostIds.length} /></div> : null;
    $[0] = filteredPostIds.length;
    $[1] = postsPerPage;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}